import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Todo este paso a paso. Lo descargué y ese mismo día fabriqué una mesa ratona para mi casa.',
    author: 'Pablo Díaz'
  }, {
    text: 'El pack vale oro. El de tornería fue una sorpresa, súper útil.',
    author: 'Mónica Gutierrez'
  }, {
    text: 'Trabajo solo y esto me agiliza un montón. Diseños rápidos de fabricar y que se venden.',
    author: 'Julián Ramírez'
  }, {
    text: 'Soy mujer y siempre pensé que la herrería era complicada. Con este sistema encontré todo perfecto.',
    author: 'Carla Vasquez'
  }, {
    text: 'Lo compré para mejorar mis ventas y realmente funciona. Los proyectos están probados, no fallan.',
    author: 'Matías Ortega'
  }, {
    text: 'Me ayudó a profesionalizar mi taller. Los clientes ahora me piden cosas que antes no me animaba a aceptar.',
    author: 'Rodrigo Iglesias'
  }, {
    text: 'Siempre quise arrancar en la herrería pero no sabía ni por dónde empezar. Con este pack fabriqué mi primer rack en TV en unos días.',
    author: 'Nicolás Ramírez'
  }, {
    text: 'Los planos son clarísimos, no te podés equivocar. Con el pack me ahorré un montón y evité tirar material.',
    author: 'Mónica Gutierrez'
  }, {
    text: 'Vendía muebles industriales y necesitaba algo que me ayudara a crecer mis servicios. Con este pack el negocio se me fue a otro nivel.',
    author: 'Víctor Muñoz'
  }, {
    text: 'Este pack me fue de muchísima ayuda a la hora de calcular materiales y saber cuánto cobrar. Ya tengo muchos más trabajos!',
    author: 'Andrés Sosa'
  }, {
    title: 'Empecé a construir',
    text: 'Siempre miré la herrería de lejos. Con este sistema empecé sin miedo y ya terminé mis primeros trabajos.',
    author: 'Martín G.',
    verified: true
  }, {
    title: 'Todo queda claro',
    text: 'Los planos están muy bien explicados. No hace falta adivinar nada, lo que ahorra errores y plata.',
    author: 'Federico S.',
    verified: true
  }, {
    title: 'Organicé mi taller',
    text: 'Tenía herramientas y ganas, pero todo estaba desorganizado. Ahora trabajo con sistema y se nota.',
    author: 'Javier R.',
    verified: true
  }, {
    title: 'Muy recomendable',
    text: 'Es práctico y va directo al punto. Reduje el tiempo de fabricación y mejoré los terminados.',
    author: 'Lucas P.',
    verified: true
  }, {
    title: 'Vale la pena',
    text: 'Con un solo proyecto recuperé la inversión. Después de eso, todo es ganancia.',
    author: 'Andrés C.',
    verified: true
  }, {
    title: 'Dejé de improvisar',
    text: 'Antes cortaba sin estar seguro. Ahora sigo los planos y trabajo tranquilo.',
    author: 'Daniel M.',
    verified: true
  }, {
    title: 'Subí de nivel',
    text: 'Vendo muebles industriales y este pack me ayudó a mejorar los diseños y cobrar mejor.',
    author: 'Sebastián F.',
    verified: true
  }, {
    title: 'Muy completo',
    text: 'Hay proyectos, presupuestador, organización y técnica. No es solo un pack de planos.',
    author: 'Ryan L.',
    verified: true
  }, {
    title: 'Perfecto para empezar',
    text: 'No tenía experiencia y pude entender todo sin abrumarme. Muy bien explicado.',
    author: 'Tomás A.',
    verified: true
  }, {
    title: 'Me dio confianza',
    text: 'Ahora tomo trabajos más grandes porque sé exactamente cuánto cobrar.',
    author: 'Pablo D.',
    verified: true
  }, {
    title: 'Se nota que es real',
    text: 'Lo hizo alguien que trabaja en un taller de verdad. Nada teórico, todo aplicable.',
    author: 'Cristian V.',
    verified: true
  }, {
    title: 'Ahorro real',
    text: 'Dejé de desperdiciar material. Solo eso ya marca una gran diferencia.',
    author: 'Nicolás E.',
    verified: true
  }, {
    title: 'Excelente sistema',
    text: 'Llevo años en herrería y aun así encontré proyectos nuevos y mejor organización.',
    author: 'Hugo T.',
    verified: true
  }];
  return <section className="relative py-4 bg-[#0A0A0A] overflow-hidden" data-id="element-155">
      {/* Background Pattern / Gradient */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-orange-500 via-slate-900 to-slate-950" data-id="element-156"></div>

      <div className="relative z-10 max-w-[1000px] mx-auto px-4" data-id="element-157">
        <div className="text-center mb-4" data-id="element-158">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white uppercase mb-2" data-id="element-159">
            +1.800 TALLERES DEJARON DE IMPROVISAR
          </h2>
          <div className="flex items-center justify-center space-x-0.5 mb-2" data-id="element-160">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-orange-400 fill-orange-400" data-id="element-161" />)}
          </div>
          <p className="text-sm text-slate-300 font-medium max-w-2xl mx-auto" data-id="element-162">
            👉 Reseñas reales de personas que convirtieron su taller en una
            fábrica rentable
          </p>
        </div>

        {/* Masonry Grid - 2 Columns */}
        <div className="columns-1 md:columns-2 gap-2 space-y-2" data-id="element-163">
          {testimonials.map((t, index) => <div key={index} className="break-inside-avoid bg-slate-900/50 backdrop-blur-sm p-3 rounded-lg border border-white/10 flex flex-col items-center text-center" data-id="element-164">
              <div className="text-orange-400 text-sm tracking-widest mb-2 select-none" data-id="element-165">
                ★★★★★
              </div>

              {t.title && <h4 className="font-bold text-white text-sm mb-1" data-id="element-166">
                  "{t.title}"
                </h4>}

              <p className="text-white/90 italic mb-2 text-sm leading-relaxed" data-id="element-167">
                "{t.text}"
              </p>

              <p className="font-bold text-orange-400 text-sm mt-auto" data-id="element-168">
                {t.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}